import { Button, Result } from "antd";
import React, { lazy, Suspense, useContext } from "react";
import { FunctionComponent } from "react";
import { Redirect, useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Switch, Route } from "react-router-dom";
import Preloader from "../containers/spinners/Preloader";
import { AuthContext } from "../contexts/auth/AuthContext";
import menuItems from "../data/menuItems";
import hasPermission from "../utils/hasPermission";
import { NewMadalR } from "../components/modal/NewMadal_R";

interface RouteType {
  path: string;
  link?: string;
  exact?: boolean;
  component?: FunctionComponent<any>;
}

const Auth = lazy(() => import("../pages/auth"));
const Logout = lazy(() => import("../pages/auth/Logout"));

const routes: RouteType[] = [
  ...menuItems.map((x) => ({
    path: x.route,
    link: x.link,
    component: x.component,
    exact: x.route === "/",
  })),
  {
    path: "/login",
    component: Auth,
  },
  {
    path: "/logout",
    component: Logout,
  },
  {
    path: "/madal",
    component: NewMadalR,
  },
];

export default function Routes() {
  const { authState } = useContext(AuthContext);
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Suspense fallback={<Preloader />}>
      <Switch>
        {routes.map(
          (x, i) =>
            x.component && (
              <Route exact={x.exact} key={i} path={x.path}>
                {hasPermission(authState.user, x.link || x.path) ? (
                  <x.component />
                ) : hasPermission(authState.user, "/") ? (
                  <Result
                    status="403"
                    title={t("permissionDenied")}
                    subTitle={t("permissionDeniedSubtitle")}
                    extra={
                      <Button
                        onClick={() => history.replace("/")}
                        type="primary"
                      >
                        {t("returnHome")}
                      </Button>
                    }
                  />
                ) : (
                  <Redirect
                    to={
                      menuItems.find((m) =>
                        hasPermission(authState.user, m.link || m.route)
                      )?.link || menuItems.find((m) =>
                        hasPermission(authState.user, m.link || m.route)
                      )?.route || "/login"
                    }
                  />
                )}
              </Route>
            )
        )}
        <Route>
          <Result
            status="404"
            title="404"
            subTitle={t("pageNotFound")}
            extra={
              <Button onClick={() => history.replace("/")} type="primary">
                {t("returnHome")}
              </Button>
            }
          />
        </Route>
      </Switch>
    </Suspense>
  );
}
